<template>
  <div>
    <h3>Adicionar perfil aos usuários</h3>

    <!-- <SGPPaginacaoComponent
      :paginacao="paginacao"
      v-if="listagemUsuarios.length"
      @sgpAtualizarPaginacao="realizarPaginacao"
      :key="paginacao"
    >      -->

      <SGPTabelaComponent
        v-if="listagemUsuarios.length"
        :colunas="colunas"
        :dados="listagemUsuarios"
        :usuarioPodeExcluir="false"
        :usuarioPodeEditar="false"
        :somenteLeitura="true"
        @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
        @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
        @sgpTabelaDeletarSelecionadoEmit="deletarSelecionados"
      ></SGPTabelaComponent>

    <!-- </SGPPaginacaoComponent> -->

    <SGPAlertaComponent v-else></SGPAlertaComponent>

    <SGPConfirmacaoDelecaoComponent
      v-if="abrirModalDeletarDados"
      @sgpCancelarDelecaoEmit="cancelarDelecao()"
      @sgpConfirmarDelecaoEmit="confirmarDelecao()"
    />
    
    <SGPLoadingComponent v-if="loadingUsuario" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import deletar from "@/././common/mixins/deletar.js";
// import FormularioUsuarioPerfilComponent from '../components/FormularioUsuarioPerfilComponent.vue'

export default {
  // components: { FormularioUsuarioPerfilComponent },
  name: 'UsuarioPerfilPage',
  mixins: [deletar],
  data () {
    return {
      // mostrarSelecionar: true,
      // mostrarEditar: true,
      // mostrarDeletar: true,
      usuariosSelecionados: [],
      abrirModal: false,
      abrirModalDeletarDados: false,
      tipoFormulario: 'salvar',
      usuario: {}
    }
  },

  created () {
    this.listarUsuarios()
    // this.listarUsuariosComPaginacao(
    //   {
    //     exibirItensDeletados: this.exibirItensDeletados
    //   });
  },

  computed: {
    ...mapGetters('usuarios', ['listaDeUsuarios','loadingUsuario']),

    listagemUsuarios () {
      if (this.listaDeUsuarios) {
        return this.listaDeUsuarios.map(usuario => {
          usuario.redirecionar = `usuarios-perfis/${usuario.id}`
          return usuario
        })
      }
      return []
    },

    // paginacao () {
    //   if (!this.listaDeUsuarios.data) return {}
      
    //   return {
    //     per_page: this.listaDeUsuarios.per_page,
    //     total: this.listaDeUsuarios.total,
    //     current_page: this.listaDeUsuarios.current_page
    //   }
    // },

    colunas () {
      return [ 
        { key: 'name', label: 'Nome', sortable: false },
        { key: 'email', label: 'E-mail', sortable: false },
        // { key: 'login', label: 'Login', sortable: false },
        { key: 'redirecionar', label: 'Perfis', sortable: false }
      ]
    }
  },

  methods: {
    ...mapActions('usuarios', [
      'listarUsuarios',
      'deletarUsuario',
      'listarUsuariosComPaginacao'
    ]),

    gerenciadorDeSelecionados (selecionados) {
      this.usuariosSelecionados = selecionados
    },

    // adicionarNovoUsuario () {
    //   this.abrirModal = true
    //   this.tipoFormulario = 'salvar'
    //   this.usuario = {}
    // },

    editarSelecionado () {
      this.tipoFormulario = 'editar'
      this.usuario = this.usuariosSelecionados[0]
      this.abrirModal = true
    },

    confirmarDelecao () {
      this.deletarDados = false      
      console.log('Confirmou a deleção')

      this.usuariosSelecionados.forEach(async usuario => {
        await this.deletarUsuario(usuario); 
      })
    },

    // fecharModal () {
    //   this.abrirModal = false
    // },

    // async realizarPaginacao (paginacao) {
    //   let payload = {
    //     ...paginacao,
    //     exibirItensDeletados: this.exibirItensDeletados
    //   }

    //   await this.listarUsuariosComPaginacao(payload);
    // },

  }
}
</script>
